import arrow_back from "../../../../img/Arrow_Vector.svg";
import { ChatProfilePicture } from "./chat-profile-picture";
import React, { useLayoutEffect, useRef, useEffect } from "react";
import styled from "@emotion/styled";
import { AddIcon } from "../../../icons/icons-svg/add-icon";
import { useApolloClient, useMutation, useQuery } from "@apollo/client";
import { GET_USER_CHATS } from "../../../../apollo-client/queries";

import { useChatStore } from "../../../../store/chatStore";

export const SmallChatBar = () => {
  const client = useApolloClient();
  
  // Use centralized chat store
  const {
    chosenChat,
    chats,
    searchContact,
    isChatOpen,
    selectChat,
    setChats,
    setSearchContact,
    setIsChatOpen,
    markMessagesAsRead,
    startNewChat,
  } = useChatStore();

  const {
    data: userChatsData,
    loading: loadingChats,
    fetchMore: fetchMoreChats,
  } = useQuery(GET_USER_CHATS, {
    variables: { search: searchContact, limit: 99 },
    onCompleted: (data) => {
      if (!chosenChat?.chatId && data?.user?.chats?.chats?.length > 0) {
        const topmostChat = data?.user?.chats?.chats[0];
        selectChat(topmostChat);
      }
      
      // Update chats in store
      if (data?.user?.chats?.chats) {
        setChats(data.user.chats.chats);
      }
    },
  });

  const chatsData = userChatsData?.user?.chats;

  const scrollContactsRef = useRef(null);



  const handleFetchMoreContacts = async () => {
    const { current } = scrollContactsRef;

    if (
      !loadingChats &&
      chatsData.chats.length < chatsData.chatsCount &&
      current.scrollTop + current.clientHeight >= current.scrollHeight
    ) {
      await fetchMoreChats({
        variables: {
          search: searchContact,
          limit: 99,
          skip: chatsData.chats.length,
        },
      });
    }
  };

  // refetch chats when searching
  useEffect(() => {
    const refetchChats = async () => {
      await client.refetchQueries({ include: [GET_USER_CHATS] });
    };
    refetchChats();
  }, [searchContact, client]);




  // Auto-select first chat if none selected
  useEffect(() => {
    if (!chosenChat && chatsData?.chats?.[0]) {
      selectChat(chatsData.chats[0]);
    }
  }, [chatsData, chosenChat, selectChat]);

  const handleChatSelection = async (chat) => {
    console.log(`Clicked in profile -> setting new chosen chat with ${chat.otherPrivateChatMember.username}`);
    
    selectChat(chat);

    if (chat.unreadMessagesCount > 0) {
      await markMessagesAsRead(chat._id, client);
    }
  };

  const handleToggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  return (
    <Container>
      <ArrowBackContainer onClick={handleToggleChat}>
        <ArrowBack src={arrow_back} isChatOpen={isChatOpen} />
      </ArrowBackContainer>
      
      {chosenChat?.chatTitle && (
        <PictureWrapper onClick={() => setIsChatOpen(true)}>
          <ChatProfilePicture
            src={chosenChat.profilePicture}
            chatTitle={chosenChat.chatTitle || ""}
            unreadMessagesCount={chosenChat.unreadMessagesCount}
            chosenChatIsOpen={isChatOpen}
            width={"60px"}
            height={"60px"}
            isBlocked={chosenChat?.isBlockedBy?.length > 0}
          />
        </PictureWrapper>
      )}
      
      <ContactsWrapper
        ref={scrollContactsRef}
        onScroll={handleFetchMoreContacts}
        onClick={() => setIsChatOpen(true)}
      >
        {userChatsData &&
          chatsData.chats
            .filter((chat) => chat._id !== chosenChat?.chatId)
            .map((chat, i) => (
              <PictureWrapper key={"PictureWrapper_" + i}>
                <ChatProfilePicture
                  key={"ChatProfilePicture_" + i}
                  src={
                    chat.picture || chat.otherPrivateChatMember.profilePicture
                  }
                  chatTitle={chat.title}
                  unreadMessagesCount={chat.unreadMessagesCount}
                  onClick={() => handleChatSelection(chat)}
                  width={"60px"}
                  height={"60px"}
                  isBlocked={chat?.isBlockedBy?.length > 0}
                />
              </PictureWrapper>
            ))}
        
        <StyledAddIcon color={"#C23D3E"} />
      </ContactsWrapper>
    </Container>
  );
};
const Container = styled.div`
  position: relative;
  width: 93px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ArrowBackContainer = styled.div`
  width: 100%;
  min-height: 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PictureWrapper = styled.div`
  width: 90px;
  margin-top: 45px;

  &:first-child {
    margin-top: 29px;
  }
`;

const StyledAddIcon = styled(AddIcon)`
  display: none;
  margin-top: 5px;
  cursor: pointer;
`;

const ArrowBack = styled("img")`
  margin-top: 20px;
  transform: ${(props) => (props.isChatOpen ? "rotate(180deg)" : "rotate(0)")};
  transition: transform 0.3s;
`;

const ContactsWrapper = styled.div`
  margin-top: 15px;
  width: 90px;
  border-right: 1px solid #c4c4c4;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: scroll;
  min-height: 100%;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    width: 4px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: transparent;
  }

  &:hover {
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: transparent;
      border-radius: 0px;
      background-color: transparent;
    }

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0px;
      -webkit-box-shadow: transparent;
      background-color: ${(props) => props.theme.scrollBarColor};
    }
  }
`;

